import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-arrow-line-right",
  "use": "icon-common-arrow-line-right-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 14\" fill=\"none\" id=\"icon-common-arrow-line-right\">\n    <path d=\"M7.82812 3.0625L11.7656 7L7.82812 10.9375\" stroke=\"currentColor\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n    <path d=\"M11.2188 7H3.23438\" stroke=\"currentColor\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol